import data from "./fr/translation.json";

const t = (
  key: string,
  variables?: {
    [key: string]: string;
  }
) => {
  // TODO: detect browser language if we really want a translation
  let translation = (data as any)?.[key] || key;

  if (variables) {
    Object.keys(variables).forEach((variable) => {
      translation = translation.replace(`{{${variable}}}`, variables[variable]);
    });
    return translation;
  }
  return translation;
};

export default t;
